<template>
    <select :id="id" :class="{'form-control':true, 'error':error}" :placeholder="placeholder"></select>
</template>

<script>
import 'selectize';

export default {
    name: 'SelectizeSelect',
    props: {
        id: {
            type: String,
            default: '',
        },
        initValue: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        valueField: {
            type: String,
            default: '',
        },
        labelField: {
            type: String,
            default: '',
        },
        searchField: {
            type: String,
            default: '',
        },
        data: {
            type: Array,
            default: () => [],
        },
        error: {
            type: Boolean,
            default: false,
        },
        onChangeValueInit: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        setKeyword: {
            type: Function,
            default: () => {
            },
        },
        searchOnload: {
            type: Function,
            default: () => {
            },
        },
    },
    data() {
        return {
            selectize: null,
        };
    },
    watch: {
        data(value) {
            if (value.length > 0) {
                this.$nextTick(() => {
                    this.loadSelectize();
                    if (this.error) {
                        $(`#${this.id}`).siblings('.selectize-control').addClass('error');
                    } else {
                        $(`#${this.id}`).siblings('.selectize-control').removeClass('error');
                    }
                });
            }
        },
        error: {
            immediate: true,
            handler(val) {
                if (val) {
                    $(`#${this.id}`).siblings('.selectize-control').addClass('error');
                } else {
                    $(`#${this.id}`).siblings('.selectize-control').removeClass('error');
                }
            },
        },
        disabled(val) {
            if (this.selectize) {
                if (val) {
                    this.selectize.disable();
                } else {
                    this.selectize.enable();
                }
            }
        },
        initValue(val) {
            if (val) {
                this.selectize.setValue(val);
            } else {
                this.selectize.setValue('');
            }
        },
    },
    methods: {
        loadSelectize() {
            const self = this;

            const selectizeObj = $(`#${this.id}`).selectize({
                valueField: self.valueField,
                labelField: self.labelField,
                searchField: self.searchField,
                preload: true,
                create: false,
                createOnBlur: true,
                maxItems: 1,
                onChange(value) {
                    if (value) {
                        const val = Object.values(self.selectize.options).find(el => String(el[self.valueField]) === value);

                        self.$emit('input', val);
                    }

                    if (self.onChangeValueInit) {
                        self.selectize.setValue('');
                    }
                },
                async load(query, callback) {
                    this.renderCache = {};
                    await self.setKeyword(query);
                    await self.searchOnload();
                    callback(self.data);
                },
            });

            this.selectize = selectizeObj[0].selectize;

            if (self.disabled) {
                this.selectize.disable();
            }
        },
    },
};
</script>
